const GRAPH_VALUES = {
  'Monthly evolution of vulnerabilities by Severity': 'monthly_evolution_by_severity',
  'Monthly evolution of vulnerabilities by Status': 'monthly_evolution_by_status',
  'Top 10 most affected assets': 'top_ten_most_affected_hosts',
  'Most repeated vulnerabilities': 'top_ten_most_repeated_vulns',
  'Vulnerabilities per Assets': 'vulnerabilities_per_host',
  'Vulnerabilities per severity': 'vulnerabilities_per_severity',
  'Vulnerabilities per status': 'vulnerabilities_per_status',
  'Vulnerabilities by Risk Score': 'vulnerabilities_by_risk_score'
};

export default GRAPH_VALUES;
